export class ValidMimeTypes {
    static types = [
        "image/jpeg",
        "image/png",
        "image/tiff",
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ];
}